import React from 'react';
import {NavLink} from 'react-router-dom';

import classes from './NavigationItem.module.css';

const navigationItem = (props) => {
    return (
        <li className={classes.NavigationItem}>
            <NavLink 
                to={props.link} 
                exact={props.exact}
                // when using module with css all css classes will have uniwue name with some hash
                // so active class of navlink would't work 
                // this can be fixed using Nvalink activeclassname and assigning it to the active class of css
                activeClassName={classes.active}

                // className={props.active ? classes.active : null}
                >
                    {props.children}
            </NavLink>
        </li>
    )
}

export default navigationItem;